<div class="lock-status">
    <div *ngIf="(vehicle?.blockerParametrId || vehicle.blockerParametrIdOut2) && isBlocked" class="lock-status__is-lock">
        <i class="pi pi-lock icon"></i>
    </div>
</div>
